import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { RadioButton as RadioButtonUI } from '@r1-frontend/ui-react/deprecated/controls/radioButton';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { COLOR_CHECKBOX_ACTIVE } from '~/src/features/center/constants/ordinary';

export const RadioContainer = styled.div`
    width: 100%;
    justify-content: space-between;
    align-items: center;
`;

interface IconProps {
    id?: string,
    name?: string,
    value?: string,
    label?: string,
    checked: boolean,
    onChange: () => void,
}

export const ThrobberContainer = styled.div`
    height: 106px;
    width: 100%;
`;

export const RadioButton = styled(RadioButtonUI)<IconProps>`
    width: 69%;
    ${FONTS.L};
    padding-left: 35px;

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.XS};
    }

    & input ~ span {
        border: 2px solid ${COLORS.grey};
    }

    & input:checked ~ span {
        background-color: ${COLORS.white} !important;
        border-color: ${COLOR_CHECKBOX_ACTIVE} !important;

        &:after {
            background-color: ${COLOR_CHECKBOX_ACTIVE} !important;
            width: 8px !important;
            height: 8px !important;
            top: 6px !important;
            left: 6px !important;
        }
    }
`;

export const Price = styled.div`
    width: fit-content;
    padding: 10px 0 8px 10px;
    ${FONTS.L};

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.XS};
    }

    @media (max-width: 350px) {
        ${FONTS.XXS};
    }
`;
